import { getDocument, getWindow } from "@thelabnyc/thelabui/src/utils/dom";

import { isElement } from "../../../utils/guards";
import { bindPrintPopupButtons } from "../../../utils/printPopup";

export const openPrintWindow = (container: HTMLDivElement | string): void => {
    const window = getWindow();
    const document = getDocument();
    if (!window || !document) {
        return;
    }

    const width = 640;
    const height = 480;
    const options = [
        ["toolbar", "no"],
        ["location", "no"],
        ["directories", "no"],
        ["status", "no"],
        ["menubar", "no"],
        ["scrollbars", "no"],
        ["resizable", "yes"],
        ["width", width],
        ["height", height],
        ["top", window.screen.height / 2 - height / 2],
        ["left", window.screen.width / 2 - width / 2],
    ];
    const encodedOptions = options
        .map((pair): string => {
            return pair.join("=");
        })
        .join(", ");
    const popup = window.open(
        "",
        "Wells Fargo Account Details",
        encodedOptions,
    );
    if (!popup) {
        return;
    }
    const messageText = isElement(container) ? container.innerHTML : container;
    if (document.head && popup.document.head) {
        popup.document.head.innerHTML = document.head.innerHTML;
    }
    popup.document.body.innerHTML = `
        <div>
            ${messageText}
            <button class="button no-print" data-popup-action="print">Print</button>
            <button class="button no-print" data-popup-action="close">Close</button>
        </div>
    `;
    bindPrintPopupButtons(popup);

    // Wait for the next repaint(requestAnimationFrame), then add a short setTimeout to ensure the content is fully rendered before calling print().
    requestAnimationFrame((): void => {
        setTimeout((): void => {
            popup.print();
        }, 100);
    });
};
